import React from 'react';
import { IconSvgProps } from '@models/common';

const Person: React.FC<IconSvgProps> = (props) => {
  const { size = 24, ...restProps } = props;
  return (
    <svg
      {...restProps}
      xmlns='http://www.w3.org/2000/svg'
      width={size}
      height={size}
      viewBox='0 0 24 24'
      fill='currentColor'>
      <path d='M12 12q-1.275 0-2.137-.862T9 9q0-1.25.863-2.125T12 6q1.25 0 2.125.875T15 9q0 1.275-.875 2.138T12 12m0-2q.425 0 .713-.288T13 9t-.288-.712T12 8t-.712.288T11 9t.288.713T12 10m-6 8v-1.9q0-.525.263-.987t.712-.738q1.15-.675 2.413-1.025T12 13t2.613.35t2.412 1.025q.45.275.713.738T18 16.1V18zm6-3q-1.025 0-2 .25T8.15 16h7.7q-.875-.5-1.85-.75T12 15m0 1h3.85h-7.7zm-8 6q-.825 0-1.412-.587T2 20v-4h2v4h4v2zM2 8V4q0-.825.588-1.412T4 2h4v2H4v4zm14 14v-2h4v-4h2v4q0 .825-.587 1.413T20 22zm4-14V4h-4V2h4q.825 0 1.413.588T22 4v4z' />
    </svg>
  );
};

export default Person;
